import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

function ArticleGrid() {
  return (
    <section id="articles" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-primary-600 uppercase tracking-wide mb-3">Spreadsheet Shopping Knowledge Base</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            SEO Guides &amp; Shopping Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Explore our curated collection of in-depth guides about GTBuy Spreadsheet, Kakobuy, Superbuy, and the world of spreadsheet-based international shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {articles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ArticleCard({ article }: { article: typeof articles[0] }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="group flex flex-col rounded-xl bg-white border border-background-200/70 overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
    >
      <div className="relative w-full h-44 sm:h-48 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-primary-700">
            {article.category}
          </span>
        </div>
      </div>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors leading-snug">
          {article.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3 flex-1">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between mt-auto pt-3 border-t border-background-100">
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span>{article.readTime}</span>
            <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
            <span>{article.updated}</span>
          </div>
          <span className="w-7 h-7 rounded-full bg-background-100 group-hover:bg-primary-100 flex items-center justify-center transition-colors">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}

export default ArticleGrid;